(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[171],{

/***/ "FQba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js + 1 modules
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/tracking/track-page/TrackPage.jsx
var TrackPage = __webpack_require__("tZiC");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// CONCATENATED MODULE: ./src/client/components/lines/submission-status-line/SubmissionStatusLine.jsx

var __jsx = react_default.a.createElement;















var SubmissionStatusLine_SubmissionStatusLine = function SubmissionStatusLine(_ref) {
  var id = _ref.id,
      text = _ref.text,
      title = _ref.title,
      titleDate = _ref.titleDate,
      link = _ref.link,
      textCustomerAccount = _ref.textCustomerAccount,
      anotherRequestLink = _ref.anotherRequestLink,
      consultRequest = _ref.consultRequest,
      travelSaved = _ref.travelSaved;
  var router = Object(next_router["useRouter"])();
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isUserLogged = appContext.isUserLogged;
  var proposalId = router.query.proposalId;
  var accountSearchUrl = routeBuilder["a" /* buildUrl */]('accountSearches');
  var prebookingformUrl = anotherRequestLink === null || anotherRequestLink === void 0 ? void 0 : anotherRequestLink.url;
  Object(i18n["a" /* addTranslationKeys */])({
    submissionStatus: {
      text: text,
      title: title,
      titleDate: titleDate,
      textCustomerAccount: textCustomerAccount,
      link: link,
      anotherRequestLink: anotherRequestLink,
      consultRequest: consultRequest,
      travelSaved: travelSaved
    }
  });

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-SubmissionStatus px-20 py-40",
    id: id,
    size: "small"
  }, proposalId && __jsx(TrackPage["a" /* TrackPage */], {
    pageName: constants["H" /* TRACK_PAGE_NAMES */].PREBOOKING_FORM_CONFIRMATION,
    payload: {
      reference_id: proposalId || ''
    }
  }), __jsx("div", {
    className: "w-full"
  }, __jsx("div", {
    className: "flex w-full justify-center"
  }, __jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-green",
    name: icons["a" /* ICONS */].CHECK_OUTLINE,
    width: "50px"
  })), __jsx("div", {
    className: "mt-12 text-center font-brand text-40 font-bold"
  }, __jsx("p", null, Object(i18n["h" /* t */])('submissionStatus.title')), __jsx("p", null, titleDate ? Object(i18n["h" /* t */])('submissionStatus.titleDate') : '')), proposalId && __jsx("p", {
    className: "mt-12 text-center text-16 font-semibold"
  }, travelSaved ? Object(i18n["h" /* t */])('submissionStatus.travelSaved', {
    proposalId: proposalId
  }) : ''), __jsx("div", {
    className: "mt-40 text-center text-16"
  }, __jsx(Text["a" /* Text */], {
    text: Object(i18n["h" /* t */])('submissionStatus.text')
  }), proposalId && __jsx(Text["a" /* Text */], {
    text: Object(i18n["h" /* t */])('submissionStatus.textCustomerAccount')
  })), __jsx("div", {
    className: "mt-40 grid grid-cols-1 gap-20 sm:flex sm:items-center sm:justify-center"
  }, proposalId && __jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].TRANSPARENT,
    colorBorder: colors["a" /* COLORS */].BLACK,
    "data-testid": "SubmissionStatusLine-consultRequest",
    onClick: function onClick() {
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_PREBOOKING_FORM_PREREG, {
        detail_click: 'check_my_request'
      });

      if (isUserLogged) {
        return router.push(accountSearchUrl);
      }

      return Object(redirectUtils["a" /* redirectToOidc */])(appContext, accountSearchUrl);
    }
  }, Object(i18n["h" /* t */])('submissionStatus.consultRequest')), anotherRequestLink ? __jsx(Button["a" /* Button */], {
    "data-testid": "SubmissionStatusLine-newRequest",
    onClick: function onClick() {
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_PREBOOKING_FORM_PREREG, {
        detail_click: 'make_new_request'
      });
      router.push(prebookingformUrl);
    }
  }, Object(i18n["h" /* t */])('submissionStatus.anotherRequestLink.label')) : __jsx(Button["a" /* Button */], {
    "data-testid": "SubmissionStatusLine-ok",
    onClick: function onClick() {
      router.push(link === null || link === void 0 ? void 0 : link.url);
    }
  }, Object(i18n["h" /* t */])('submissionStatus.link.label')))));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/submission-status/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (SubmissionStatusLine_SubmissionStatusLine);

/***/ }),

/***/ "k9PE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return redirectToUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return redirectToOidc; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LJOr");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Mkub");
/* harmony import */ var _graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ESA2");
/* harmony import */ var _ple_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("6jSF");









function redirectToUri(router) {
  return function (uri) {
    return function () {
      var redirectUri = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"](_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getLocation(), uri).toString();
      router.push(redirectUri);
    };
  };
}
function redirectToOidc(appContext, redirectUrl) {
  var locale = appContext.locale,
      isSeller = appContext.isSeller,
      isCmta = appContext.isCmta;

  if (true) {
    var currentLocation = new urijs__WEBPACK_IMPORTED_MODULE_4___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getLocation()).removeSearch('forceAuth');
    var redirectPath = redirectUrl || currentLocation.pathname();
    var redirectUri = new urijs__WEBPACK_IMPORTED_MODULE_4___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getOrigin()).path(redirectPath).query(currentLocation.search()).hash(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getLocationPart('hash')).toString();
    Object(_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_7__[/* clearAllCacheFront */ "a"])();
    _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].setLocation(isSeller ? Object(_ple_utils__WEBPACK_IMPORTED_MODULE_8__[/* buildSellerSigninUrl */ "e"])({
      locale: locale,
      redirectUri: redirectUri,
      isCmta: isCmta
    }) : Object(_ple_utils__WEBPACK_IMPORTED_MODULE_8__[/* buildSigninUrl */ "f"])({
      locale: locale,
      redirectUri: redirectUri
    }));
  }
}

/***/ })

}]);